import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Tooltip.html?raw';
import on from 'dojo/on';
import FloatingContainer from './FloatingContainer';
import { TooltipConfig } from "./FloatingTypes";


class Tooltip extends compose(_WidgetBaseSP) {
    templateString: any = template;

    contentWrapper: HTMLElement;
    mainContent: HTMLElement;
    mainContentContainer: HTMLElement;
    subtitle: HTMLElement;
    subtitleContainer: HTMLElement;
    heading: HTMLElement;
    headingContainer: HTMLElement;
    topBar: HTMLElement;
    iconContainer: HTMLElement;

    private config: TooltipConfig = null;

    private floatingContainer: MdsLax<InstanceType<typeof FloatingContainer>>;
    private sourceTarget: any = null;

    private attachedEvents: Array<dojo.Handle> = [];

    private initialMouseX: any;
    private initialMouseY: any;

    setup(config: TooltipConfig) {
        if (!config.targetnode || !config.content) return;

        if (config.enableHover !== false) {
            this.attachedEvents.push(on(config.targetnode, "mouseenter", lang.hitch(this, this._onMouseEnter)));
            this.attachedEvents.push(on(config.targetnode, "mouseleave", lang.hitch(this, this._onMouseLeave)));
        }

        if (config.enableClick === true) {
            this.attachedEvents.push(on(config.targetnode, "click", lang.hitch(this, this._onClick)));
        }

        if (config.followMouse === true) {
            this.attachedEvents.push(on(config.targetnode, "mousemove", lang.hitch(this, this._onMouseMove)));
        }

        this.setHeading(config.heading);
        this.setContent(config.content);
        this.setIcon(config.icon);
        this.setSubtitle(config.subtitle);

        this.config = config;
    }

    setHeading(heading: string) {
        this.heading.innerHTML = heading;
        this.hideNode(this.headingContainer, !heading);
    }

    setContent(content: string | HTMLElement) {
        if (typeof (content) == "string") {
            this.UiModder.domAttr.set(this.mainContent, "innerHTML", content);
        } else {
            this.UiModder.domConstruct.place(content, this.mainContent, "only");
        }
    }

    setIcon(iconclass: string) {
        if (iconclass) {
            let icon = this.createFontawesomeIcon(iconclass);
            this.UiModder.domConstruct.place(icon, this.iconContainer, "only");
            this.hideNode(this.iconContainer, false);
        } else {
            this.UiModder.domConstruct.empty(this.iconContainer);
            this.hideNode(this.iconContainer);
        }
    }

    setSubtitle(text: string) {
        this.subtitle.innerHTML = text;
        this.hideNode(this.subtitleContainer, !text);
    }

    private _mouseEnterHandle: any = null;
    private _mouseLeaveHandle: any = null;
    private _mouseClickHandle: any = null;
    private isShowing: boolean = false;

    private _onClick(evt: MouseEvent) {
        
        if (!this.config.enableClick) return;
        if (this.isShowing) {
            evt.stopPropagation();
            this._onMouseLeave(evt);
            return;
        } else {
            if (this._mouseEnterHandle) {
                clearTimeout(this._mouseEnterHandle);
                this._mouseEnterHandle = null;
            }
            evt.stopPropagation();
            this.show(evt);
        }
    }
    private _onMouseEnter(evt: MouseEvent) {
        if (this.isShowing) return;

        if (this._mouseLeaveHandle) {
            clearTimeout(this._mouseLeaveHandle);
            this._mouseLeaveHandle = null;
        }

        if (!this._mouseEnterHandle) {
            clearTimeout(this._mouseEnterHandle);
            this._mouseEnterHandle = null;
        }
        this._mouseEnterHandle = setTimeout(lang.hitch(this, this.show, evt), this.config.delayMS ? this.config.delayMS : 1000);
    }

    private show(evt: MouseEvent) {
        this.isShowing = true;

        try {
            this.floatingContainer = new FloatingContainer();
            this.UiModder.domStyle.set(this.floatingContainer.domNode, "pointerEvents", "none");
            this.floatingContainer.setContent(this.contentWrapper);
            this.floatingContainer.open(evt, null, false, true);//, document.body, 25); // bei document.body funktionieren agendaview-Tooltips nicht. und andere auch nicht
            on(this.floatingContainer, "close", lang.hitch(this, this._onCloseFloatingContainer));

            this.initialMouseX = evt.clientX;
            this.initialMouseY = evt.clientY;
        } catch (ex) {
            this.isShowing = false;
        }
    }

    private _onMouseLeave(evt: MouseEvent) {
        if (this.isShowing) {
            this.isShowing = false;
            if (this._mouseLeaveHandle) {
                clearTimeout(this._mouseLeaveHandle);
                this._mouseLeaveHandle = null;
            }
            if (this.config._debugKeepOpen > 0) {
                this._mouseLeaveHandle = setTimeout(lang.hitch(this.floatingContainer, "close", true), this.config._debugKeepOpen);
            } else {
                this._mouseLeaveHandle = setTimeout(lang.hitch(this.floatingContainer, "close", true), 100);
            }
        }

        if (this._mouseEnterHandle) {
            clearTimeout(this._mouseEnterHandle);
            this._mouseEnterHandle = null;
        }
    }

    private _onMouseMove(evt: MouseEvent) {
        if (this.isShowing && this.floatingContainer) {
            //console.debug("_onMouseMove", evt.clientX, evt.clientY, evt);
            
            let diffX = evt.clientX - this.initialMouseX;
            let diffY = evt.clientY - this.initialMouseY;

            this.floatingContainer.setOffset(diffX, diffY);
        }
    }

    private _onCloseFloatingContainer() {
        this.isShowing = false;
        this.floatingContainer = null;
        this.UiModder.domConstruct.place(this.contentWrapper, this.domNode);
    }

    destroy() {
        for (let handle of this.attachedEvents) {
            handle.remove();
        }
        super.destroy.apply(this, arguments as any);
    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse     
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///

        this.attachedEvents = [];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(Tooltip);
